"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sesto-fiorentino": {
    "ceppeto": [{
      "hkey": "e8760ff4",
      "slug": "sesto-fiorentino",
      "name": "Sesto Fiorentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57628e0d": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "skipSearch": false
    }],
    "canonica": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sesto-fiorentino"
    }],
    "8db10a79": [{
      "hkey": "e8760ff4",
      "slug": "sesto-fiorentino",
      "name": "Sesto Fiorentino",
      "primary": true,
      "skipSearch": false
    }],
    "castiglione": [{
      "hkey": "e8760ff4",
      "slug": "sesto-fiorentino",
      "name": "Sesto Fiorentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87543bf2": [{
      "hkey": "e8760ff4",
      "slug": "sesto-fiorentino",
      "name": "Sesto Fiorentino",
      "primary": true,
      "skipSearch": false
    }],
    "099e4ac0": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "skipSearch": false
    }],
    "cercina": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eacaeed8": [{
      "hkey": "4199ee57",
      "slug": "colonnata-camporella",
      "name": "Colonnata-Camporella",
      "primary": true,
      "skipSearch": false
    }],
    "colonnata": [{
      "hkey": "4199ee57",
      "slug": "colonnata-camporella",
      "name": "Colonnata-Camporella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cb2cdbbc": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "skipSearch": false
    }],
    "montorsoli": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sesto-fiorentino"
    }],
    "27c6d690": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "skipSearch": false
    }],
    "morello": [{
      "hkey": "e67d408e",
      "slug": "cercina-monte-morello",
      "name": "Cercina-Monte Morello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sesto-fiorentino"
    }]
  }
};
exports["default"] = _default;